"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _scriptLoader = _interopRequireDefault(require("../../../helpers/scriptLoader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable no-restricted-globals */

var baseClasses = (0, _cssClassesHelper.getBEMClasses)('withdraw-form');
var TrustpayWithdrawWorkflowComponent = function TrustpayWithdrawWorkflowComponent(_ref) {
  var url = _ref.url;
  if (url) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('trustpay-form')
    }, /*#__PURE__*/_react["default"].createElement("form", {
      action: location.href,
      className: "paymentWidgets",
      "data-brands": "VISA MASTER AMEX"
    }), /*#__PURE__*/_react["default"].createElement(_scriptLoader["default"], {
      url: url
    }));
  }
  return null;
};
TrustpayWithdrawWorkflowComponent.defaultProps = {
  url: ''
};
TrustpayWithdrawWorkflowComponent.propTypes = {
  url: _propTypes["default"].string
};
var _default = exports["default"] = TrustpayWithdrawWorkflowComponent;